var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"dragscroll",rawName:"v-dragscroll"}],staticClass:"cw"},[_c('img',{attrs:{"src":require("@/assets/404.png"),"alt":"","width":"400"}}),_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.goHome}},[_vm._v("返回上一页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }